// import { VehicleCategory } from "./categories/types";
import { transformVehicleManufacturer } from "./manufacturers/transformations";
import { transformVehicleModel } from "./models/transformations";
import {
  Vehicle,
  VehicleCategory,
  VehicleEditFormValues,
  VehicleImage,
  VehicleRow,
} from "./types";
import { transformVehicleType } from "./types/transformations";

/*---------------------------------------------------------------------------------------
    VEHICLE SEARCH
  -----------------------------------------------------------------------------------------*/

export const transformVehicleRow = (res: any): VehicleRow => {
  return {
    id: res.id,
    kmTraveled: res.kmTraveled,
    manufacturer: transformVehicleManufacturer(res.manufacturer),
    model: transformVehicleModel(res.model),
    type: transformVehicleType(res.type),
    similar: res.similar.map(transformVehicle),
  };
};


/*---------------------------------------------------------------------------------------
    VEHICLE IMAGE
  -----------------------------------------------------------------------------------------*/

  export const transformVehicleImage = (res: any): VehicleImage => {
    return {
      images: res.images,
    };
  };
  

/*---------------------------------------------------------------------------------------
    VEHICLE CREATE/EDIT
  -----------------------------------------------------------------------------------------*/

export const transformVehicleOnCreate = (
  formValues: VehicleEditFormValues
): any => ({
  name: formValues.name,
});

export const transformVehicleOnUpdate = (
  formValues: VehicleEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
});

export const transformVehicle = (res: any): Vehicle => {

  return {
    id: res.id,
    kmTraveled: res.kmTraveled,
    manufacturer: res.manufacturer,
    model: res.model,
    type: res.type,
  };
};

export const transformVehicleCategory = (
  formValues: VehicleCategory
): any => ({
  id: formValues.id,
  name: formValues.name,
});




// export const transformVehicleStatus = (res: any): VehicleStatus => {
//   return {
//     id: res.id,
//     name: res.name,
//   };
// };

// export const transformFuelTypes = (res: any): FuelType => {
//   return {
//     id: res.id,
//     name: res.name,
//   };
// };



// export const transformVehicleCategory = (res: any): VehicleCategory => {
//   return {
//     id: res.id,
//     image: res.image,
//     name: res.name,
//   };
// };
